import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Configuration } from "../../shared/configurations/shared.config";



@Injectable()

export class NotificationsTabService {
    constructor(private http: Http) { }

    getStaffList(id) {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.getStaffList + id).map(res => res.json());
    }

    SavePolicyStaffAssociation(policyStaff) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.SavePolicyStaffAssociation, policyStaff)

    }
    getUsersBySubscriber(filtration){
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.getUsersBySubscriber, filtration).map(res => res.json());

    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/notification-tab-form.service.ts